import React, { createContext, useReducer } from 'react';
import PropTypes from 'prop-types';
import ContextDevTool from 'react-context-devtool';
import focusModeReducer, { initialState } from '../reducers/focusModeReducer';

export const FocusModeContext = createContext();

const FocusModeProvider = ({ children }) => {
  const useFocusModeState = useReducer(focusModeReducer, initialState);
  return (
    <FocusModeContext.Provider value={[...useFocusModeState]}>
      <ContextDevTool
        context={FocusModeContext}
        id="FocusModeContext"
        displayName="FocusMode Context"
      />
      {children}
    </FocusModeContext.Provider>
  );
};

FocusModeProvider.propTypes = {
  children: PropTypes.element.isRequired,
};

export default FocusModeProvider;
